import { useMemo } from 'react';
import type { Node } from '@/types/node';

export const useFigmaLayersDrawer = (selectedNodes: Node[]): Node | undefined => {
  return useMemo(() => {
    if (selectedNodes.length !== 1) return undefined;
    const node = selectedNodes[0];
    return node.type === 'figma_compositor' ? node : undefined;
  }, [selectedNodes]);
};
